import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

export const InfoTip = ({ text, testId }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" className="text-slate-400 hover:text-[#425B76] transition-colors" data-testid={testId} aria-label="Definition">
          <Info className="w-3.5 h-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs bg-slate-900 text-white leading-relaxed">
        {Array.isArray(text) ? text.map((t) => <p key={t} className="mb-1 last:mb-0">{t}</p>) : text}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
